<template>
  <sidepanel
    id="panel-edit-test"
    :wide="true"
    @open="init"
    :processing="processing"
    :title="test ? test.kit.name : ''"
    :save="saveTest"
    @close="reset"
  >
    <template v-if="test">
      <div class="options">
        <button
          v-for="(obj, key) in statusTypes"
          :key="key"
          :class="{ active: key === test.status }"
          @click="test.status = key"
        >
          {{ obj.title }}
        </button>
      </div>

      <template v-if="test.status === 'completed'">
        <h2>Test values</h2>
        <base-input
          v-for="(marker, index) in test.kit.markers"
          :label="marker.title"
          type="number"
          v-model="marker.value"
          :key="'input-' + index"
        />
      </template>
      <textarea
        placeholder="Event description"
        class="input-event-description"
        v-model="eventNote"
      ></textarea>

      <input type="checkbox" v-model="test.billed" id="cb-billed" /><label
        for="cb-billed"
        >Billed (DKK{{ test.kit.cost }})</label
      ></template
    ></sidepanel
  >
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      test: null,
      processing: false,
      eventNote: ""
    };
  },
  methods: {
    async init() {
      this.processing = true;
      const { testId, userId } = this.$store.getters.sidepanel(
        "panel-edit-test"
      ).payload;
      this.test = await this.$store.dispatch("TestsStore/get", {
        testId,
        userId
      });
      if (!this.test.note) this.test.note = "";
      this.processing = false;
    },
    saveTest() {
      // console.log("Saving");
      this.$store.dispatch("TestsStore/save", {
        test: this.test,
        eventNote: this.eventNote
      });
      this.removePanel();
    },
    reset() {
      this.test = null;
      this.eventNote = "";
    }
  },
  computed: {
    ...mapState("TestsStore", ["statusTypes"]),
    testId() {
      return this.$store.getters.sidepanel("panel-edit-test")
        ? this.$store.getters.sidepanel("panel-edit-test").payload
        : null;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";

textarea.input-event-description {
  width: 100%;
  height: @h6;
  font: inherit;
  border: 1px solid #333;
  background-color: #eee;
  color: #333;
  padding: @hh;
}
</style>
